import { useEffect } from "react";

const SITE_NAME = "痴汉电车";

function createMeta(selector: string) {
  const element = document.createElement("meta");
  if (selector.includes('property="')) {
    element.setAttribute("property", selector.replace(/.*property="([^"]+)".*/, "$1"));
  } else {
    element.setAttribute("name", selector.replace(/.*name="([^"]+)".*/, "$1"));
  }
  document.head.appendChild(element);
  return element;
}

function setMeta(selector: string, content: string) {
  const element = document.head.querySelector<HTMLMetaElement>(selector) ?? createMeta(selector);
  element.setAttribute("content", content);
}

interface PageMeta {
  title: string;
  description: string;
  keywords?: string;
  suffix?: boolean;
}

export default function usePageMeta({ title, description, keywords, suffix = true }: PageMeta) {
  useEffect(() => {
    const fullTitle = suffix ? `${title} - ${SITE_NAME}` : title;
    document.title = fullTitle;
    setMeta('meta[name="description"]', description);
    if (keywords) setMeta('meta[name="keywords"]', keywords);
    setMeta('meta[property="og:title"]', fullTitle);
    setMeta('meta[property="og:description"]', description);
    setMeta('meta[property="og:type"]', "website");
  }, [title, description, keywords, suffix]);
}